// src/app/auth/auth.service.ts
import { Injectable } from '@angular/core';
import { SESSION_STORAGE_KEYS } from './session-storage-keys';

@Injectable()
export class AuthService {
  constructor() {}

  public isAuthenticated(): boolean {
    let tokens: any = JSON.parse(sessionStorage.getItem(SESSION_STORAGE_KEYS.tokens));
    return (tokens && tokens.length > 0);
  }
}
